/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Open_HistoryInputs */

const en_us2_search_open_history = /** @type {(inputs: Search_Open_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the summary`)
};

const pt_br2_search_open_history = /** @type {(inputs: Search_Open_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver o resumo`)
};

const es_419_search_open_history = /** @type {(inputs: Search_Open_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver el resumen`)
};

const pt_pt2_search_open_history = /** @type {(inputs: Search_Open_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver o resumo`)
};

const fr_fr2_search_open_history = /** @type {(inputs: Search_Open_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir le résumé`)
};

const de_de2_search_open_history = /** @type {(inputs: Search_Open_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenfassung ansehen`)
};

const it_it2_search_open_history = /** @type {(inputs: Search_Open_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi il riepilogo`)
};

/**
* | output |
* | --- |
* | "See the summary" |
*
* @param {Search_Open_HistoryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_open_history = /** @type {((inputs?: Search_Open_HistoryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Open_HistoryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_open_history(inputs)
	if (locale === "es-419") return es_419_search_open_history(inputs)
	if (locale === "pt-PT") return pt_pt2_search_open_history(inputs)
	if (locale === "fr-FR") return fr_fr2_search_open_history(inputs)
	if (locale === "de-DE") return de_de2_search_open_history(inputs)
	if (locale === "it-IT") return it_it2_search_open_history(inputs)
	return en_us2_search_open_history(inputs)
});
export { search_open_history as "search.open_history" }